// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopDescription_container__giFm_","description":"ShopDescription_description__u_YGH","showAllButtonText":"ShopDescription_showAllButtonText__ghg3P"};